import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { FormInputComponent } from '../form-input.component';
import { ToFormControlPipe } from '../../../../pipes/to-form-control/to-form-control.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';

@Component({
  selector: 'aw-number-input',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageComponent,
    ToFormControlPipe,
    AppendTestIdPipe,
  ],
  templateUrl: './number-input.component.html',
})
export class NumberInputComponent
  extends FormInputComponent
  implements OnInit, OnDestroy
{
  public step: number = 1;

  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit() {
    this.ngControl.control!.addValidators(this.conformsToStepSize());
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.ngControl.control!.removeValidators(this.conformsToStepSize());
  }

  public increaseValue(): void {
    if (!this.ngControl.control!.value) {
      this.setValue(this.step);
    } else {
      this.setValue(this.ngControl.control!.value + this.step);
    }
  }

  public decreaseValue(): void {
    if (!this.ngControl.control!.value) {
      this.setValue(-this.step);
    } else {
      this.setValue(this.ngControl.control!.value - this.step);
    }
  }

  private setValue(value: number): void {
    this.ngControl.control!.setValue(value);
    this.ngControl.control!.updateValueAndValidity();
  }

  private findPrecision(value: number = 0): number {
    return value.toString().split('.')?.[1]?.length ?? 0;
  }

  private conformsToStepSize(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const stepPrecision: number = this.findPrecision(this.step);
      const valuePrecision: number = this.findPrecision(control.value);

      const remnant: number = control.value ? control.value % this.step : 0;
      return remnant > 0 || valuePrecision > stepPrecision
        ? { stepSize: true }
        : null;
    };
  }
}
